export default __webpack_public_path__ + "static/brand-partners.url-e68950c486dd0c61b20061ac63b66c10.svg";